import Link from "next/link";
import type { ReactNode } from "react";
import { PrimaryButton, SecondaryButton } from "ui/components";
import { BookIcon, MailIcon } from "ui/iconsN";
import { menuStore } from "../MenuInner";

type Props = {
  catalogueImage: ReactNode;
};
export const Side = ({ catalogueImage }: Props) => (
  <div className="flex flex-col">
    <Link href="/newsletters/" onClick={() => menuStore.set(null)}>
      <SecondaryButton className=" w-full">
        <MailIcon />
        Recevoir la newsletter
      </SecondaryButton>
    </Link>
    <Link href="/abonnements/" onClick={() => menuStore.set(null)}>
      {catalogueImage}
      <PrimaryButton className="-translate-y-4">
        <BookIcon />
        Demandez votre catalogue
      </PrimaryButton>
    </Link>
  </div>
);
